import { tApi } from 'tplus-api';
import { TStore } from 'tplus-poslogin'

export default class CountApi {
    /**
     * 获取待配送订单列表数量
     * @param {*} stparam 
     */
    static async GetEcommerceUnSeedsCount() {
        const storeInfo = TStore.restore()
        const IdStore = storeInfo.storeID
        return await tApi({ IdStore }, 'chanjet.RE.newRetail.GetEcommerceUnSeedsCount', false, false);
    }
}